module.exports = __webpack_public_path__ + "img/mandiriva-light.c3e6ec4e.png";